import { useTranslation } from 'react-i18next';
import { MAIN_SITE_URL } from '@/mocks/site';

const heroImage =
  'https://readdy.ai/api/search-image?query=Soft%20abstract%20minimal%20background%20with%20fresh%20green%20and%20warm%20cream%20organic%20flowing%20shapes%20subtle%20gradient%20clean%20modern%20editorial%20aesthetic%20gentle%20soft%20light%20airy%20calm%20composition%20high%20resolution%20no%20text&width=1600&height=900&seq=hero-usfans&orientation=landscape';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img src={heroImage} alt="USFans Spreadsheet research hub" className="h-full w-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
      </div>

      <div className="relative mx-auto flex min-h-[520px] w-full max-w-5xl flex-col items-center justify-center px-4 py-20 text-center md:min-h-[600px] md:px-6">
        <span className="animate-rise inline-flex items-center gap-2 rounded-full border border-background-50/40 bg-background-50/10 px-4 py-1.5 text-sm font-medium text-background-50 backdrop-blur">
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-information-line text-base"></i>
          </span>
          USFans Spreadsheet 2026
        </span>

        <h1 className="animate-rise mt-6 w-full font-heading text-3xl font-extrabold leading-tight text-background-50 md:text-5xl">
          {t('home.heroTitle')}
        </h1>

        <p className="animate-rise mt-5 w-full max-w-2xl text-base leading-relaxed text-background-50/90 md:text-lg">
          {t('home.heroSub')}
        </p>

        <div className="animate-rise mt-8 flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <span className="flex h-5 w-5 items-center justify-center">
              <i className="ri-arrow-right-up-line text-lg"></i>
            </span>
            {t('home.primaryCta')}
          </a>
          <a
            href="/article/usfans-spreadsheet-guide"
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/60 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10 sm:w-auto"
          >
            {t('home.secondaryCta')}
          </a>
        </div>

        <p className="animate-rise mt-8 text-sm text-background-50/80">{t('home.trustLine')}</p>
      </div>
    </section>
  );
}